const ACSB_SCRIPT_SRC = "https://acsbapp.com/apps/app/dist/js/app.js"

const ACSB_INIT_OPTIONS = {
  statementLink: "",
  footerHtml: "",
  hideMobile: false,
  hideTrigger: false,
  disableBgProcess: false,
  language: "en",
  position: "right",
  leadColor: "#146FF8",
  triggerColor: "#146FF8",
  triggerRadius: "50%",
  triggerPositionX: "right",
  triggerPositionY: "bottom",
  triggerIcon: "people",
  triggerSize: "bottom",
  triggerOffsetX: 20,
  triggerOffsetY: 20,
  mobile: {
    triggerSize: "small",
    triggerPositionX: "right",
    triggerPositionY: "bottom",
    triggerOffsetX: 20,
    triggerOffsetY: 20,
    triggerRadius: "20"
  }
}

const isAcsbEnabled = () => {
  const flag = import.meta.env.VITE_ACSBAPP
  return flag === true || flag === "true"
}

export function initAcsbApp() {
  if (!isAcsbEnabled()) {
    return
  }

  if (document.querySelector(`script[src="${ACSB_SCRIPT_SRC}"]`)) {
    return
  }

  const script = document.createElement("script")
  script.src = ACSB_SCRIPT_SRC
  script.async = true
  script.onload = function () {
    if (typeof window.acsbJS !== "undefined") {
      window.acsbJS.init(ACSB_INIT_OPTIONS)
    }
  }
  ;(document.head || document.body).appendChild(script)
}
